var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container view-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "search-btn-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        label: _vm.$t("BusinessPurchaseApply.header.code"),
                        prop: "code",
                        placeholder: _vm.$t(
                          "BusinessPurchaseApply.header.code"
                        ),
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "code", $$v)
                        },
                        expression: "queryParams.code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseOrderList.order"),
                          prop: "purchaseCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessPurchaseOrderList.order"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.purchaseCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "purchaseCode", $$v)
                            },
                            expression: "queryParams.purchaseCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseOrderList.type"),
                          prop: "purchaseType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessPurchaseOrderList.type"
                            ),
                            "option-list": _vm.PURCHASE_TYPE,
                          },
                          model: {
                            value: _vm.queryParams.purchaseType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "purchaseType", $$v)
                            },
                            expression: "queryParams.purchaseType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseApply.status"),
                          prop: "status",
                        },
                      },
                      [
                        _c(
                          "BjTooltip",
                          {
                            attrs: {
                              content: _vm.$t("BusinessPurchaseApply.status"),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "BusinessPurchaseApply.status"
                                ),
                                "option-list": _vm.PURCHASE_STATUS_LIST,
                              },
                              model: {
                                value: _vm.queryParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "status", $$v)
                                },
                                expression: "queryParams.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseApply.isFill"),
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("BusinessPurchaseApply.isFill"),
                            "option-list": _vm.STATUS_YES_NUM,
                          },
                          model: {
                            value: _vm.queryParams.isFill,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "isFill", $$v)
                            },
                            expression: "queryParams.isFill",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        label: _vm.$t("BusinessPurchaseApply.header.skuCode"),
                        prop: "skuCode",
                        placeholder: _vm.$t(
                          "BusinessPurchaseApply.header.skuCode"
                        ),
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.skuCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "skuCode", $$v)
                        },
                        expression: "queryParams.skuCode",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "seniorForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseApply.header.applicant"
                          ),
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessPurchaseApply.header.applicant"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.buyerName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "buyerName", $$v)
                            },
                            expression: "queryParams.buyerName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseApply.header.arrivalTime"
                          ),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessPurchaseApply.header.arrivalTime"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_expected,
                            callback: function ($$v) {
                              _vm.queryParamsTime_expected = $$v
                            },
                            expression: "queryParamsTime_expected",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("table.createTimeText") } },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t("table.createTimeText"),
                          },
                          model: {
                            value: _vm.queryParamsTime_create,
                            callback: function ($$v) {
                              _vm.queryParamsTime_create = $$v
                            },
                            expression: "queryParamsTime_create",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "beforeSearchBtn",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 24 - _vm.colSpan } },
                  [
                    _c("BjStatusTabs", {
                      attrs: {
                        value: _vm.auditTabsValue,
                        "option-list": _vm.TAB_LIST,
                      },
                      on: { handleTabClick: _vm.handleTabClick },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: tableOperationProp.notSingle,
                          type: "primary",
                        },
                        on: { click: _vm.copyPurchaseOrder },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BusinessPurchaseApply.copyPurchaseOrder")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "code"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDetail(row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(row[col.prop]))]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: { copy: row[col.prop] },
                                          }),
                                        ]
                                      : col.prop === "purchaseCode"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toPurchase(row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(row[col.prop]))]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: { copy: row[col.prop] },
                                          }),
                                        ]
                                      : col.prop === "isFill"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: row[col.prop]
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_NUM.bjGet(
                                                    row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.PURCHASE_STATUS_LIST.bjGet(
                                                  row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "purchaseType"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.PURCHASE_TYPE.bjGet(
                                                  row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "skuCode"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row.goodsList[0]
                                                  ? row.goodsList[0].skuCode
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                row[col.prop],
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "view-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDetail(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BusinessPurchaseOrderList.View"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    row.status === "CANCELLED"
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDelete(row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("delText")))]
                                        )
                                      : _vm._e(),
                                    !_vm.operationList.includes(row.status)
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                row.status ===
                                                "THIRD_AUDIT_REJECTED",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEdit(row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("editText")))]
                                        )
                                      : _vm._e(),
                                    !_vm.operationList.includes(row.status) &&
                                    _vm.auditTabsValue !== "all"
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                row.status ===
                                                "THIRD_AUDIT_REJECTED",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onAudit(row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseApply.review"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    !_vm.operationList.includes(row.status)
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onAbandon(row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseOrderList.Abandoned"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "BjDialog",
        {
          attrs: {
            title: _vm.$t("BusinessPurchaseApply.cancelledPurchase"),
            visible: _vm.visible,
            width: "600px",
          },
          on: {
            close: function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _c("h4", [
            _vm._v(_vm._s(_vm.$t("BusinessPurchaseApply.cancelReason")) + ":"),
          ]),
          _c("BjInput", {
            attrs: {
              type: "textarea",
              placeholder: _vm.$t("inputText"),
              maxlength: _vm.MAX_LENGTH.REMARK,
              "show-word-limit": "",
              clearable: "",
              rows: "5",
            },
            model: {
              value: _vm.form.cancelReason,
              callback: function ($$v) {
                _vm.$set(_vm.form, "cancelReason", $$v)
              },
              expression: "form.cancelReason",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onAbandonConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }